import VDialog from './VDialog'

export default {
  VDialog
}



// WEBPACK FOOTER //
// ./src/components/dialogs/index.js